import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ace4340&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4ace4340&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace4340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ace4340')) {
      api.createRecord('4ace4340', component.options)
    } else {
      api.reload('4ace4340', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ace4340&scoped=true", function () {
      api.rerender('4ace4340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Navbar/index.vue"
export default component.exports